import { j as n } from "../jsx-runtime-Wav_3Wde.js";
import { s as x } from "../index.esm-DOxVcNnO.js";
import { forwardRef as b } from "react";
import { styled as s } from "styled-components";
import { compose as j, width as q, flexbox as R, space as I } from "styled-system";
const h = /* @__PURE__ */ s.div.withConfig({
  shouldForwardProp: (o) => x(o)
}).withConfig({
  componentId: "sc-74c75272-0"
})([
  "",
  " ",
  ""
], ({ theme: o, variant: t }) => o.components.radioGroup.defaultContainer[t], j(q, R, I)), $ = /* @__PURE__ */ s(h).withConfig({
  componentId: "sc-74c75272-1"
})([
  "",
  ""
], ({ theme: o }) => o.components.radioGroup.borderedContainer), u = /* @__PURE__ */ s.span.withConfig({
  shouldForwardProp: (o) => ![
    "error",
    "variant",
    "bordered"
  ].includes(o)
}).withConfig({
  componentId: "sc-74c75272-2"
})([
  "",
  ""
], ({ theme: o, variant: t }) => o.components.radioGroup.radioButton[t]), F = {
  type: "radio"
}, B = /* @__PURE__ */ s.input.withConfig({
  shouldForwardProp: (o) => ![
    "variant",
    "error"
  ].includes(o)
}).attrs(F).withConfig({
  componentId: "sc-74c75272-3"
})([
  "",
  ""
], ({ theme: o, variant: t }) => o.components.radioGroup.radioOption[t]({
  theme: o,
  RadioButton: u
})), G = /* @__PURE__ */ s.label.withConfig({
  shouldForwardProp: (o) => ![
    "error",
    "bordered"
  ].includes(o)
}).withConfig({
  componentId: "sc-74c75272-4"
})([
  "",
  ""
], ({ theme: o, variant: t }) => o.components.radioGroup.radioButtonLabel[t]), P = ({ variant: o, defaultValue: t, checkedValue: e, bordered: c, value: d, name: i }) => {
  const p = t === d, r = e === d, l = c && o === "default" ? $ : h, f = i ? `${i}-${d}` : d;
  return {
    defaultChecked: p,
    Wrapper: l,
    checked: r,
    qaId: f
  };
}, A = /* @__PURE__ */ b(({ value: o, children: t, name: e, defaultValue: c = "", bordered: d = !1, error: i = !1, checkedValue: p, variant: r = "default", wrapperProps: l, ...f }, m) => {
  const { defaultChecked: w, Wrapper: C, checked: g, qaId: a } = P({
    variant: r,
    defaultValue: c,
    checkedValue: p,
    bordered: d,
    value: o,
    name: e
  });
  return /* @__PURE__ */ n.jsx(C, {
    "data-qa-id": `${a}-radio`,
    checked: g,
    variant: r,
    ...l,
    children: /* @__PURE__ */ n.jsxs(G, {
      "data-qa-id": `${a}-label`,
      error: i,
      bordered: d,
      variant: r,
      id: `${a}-label`,
      children: [
        /* @__PURE__ */ n.jsx(B, {
          "data-qa-id": `${a}-input`,
          "aria-labelledby": `${a}-label`,
          defaultChecked: w,
          variant: r,
          name: e,
          ref: m,
          value: o,
          error: i,
          ...f
        }),
        r !== "square" ? /* @__PURE__ */ n.jsxs(n.Fragment, {
          children: [
            /* @__PURE__ */ n.jsx(u, {
              "data-qa-id": a,
              error: i,
              bordered: d,
              variant: r
            }),
            t
          ]
        }) : /* @__PURE__ */ n.jsx(u, {
          "data-qa-id": a,
          error: i,
          bordered: d,
          variant: r,
          children: t
        })
      ]
    })
  }, a);
});
export {
  A as default
};
